import { Button, Menu, MenuList, MenuPopover, MenuTrigger, MenuItemSwitch, MenuCheckedValueChangeEvent, MenuCheckedValueChangeData, Switch, SwitchOnChangeData } from '@fluentui/react-components';
import { AppsAddInRegular, AppsFilled } from "@fluentui/react-icons";
import { ChangeEvent, FC, useState } from 'react';
import './PluginsMenu.scss';
import { getPluginIcon } from '../../Utils/plugin';
import { useConfirm } from '../../Contexts/hooks';
import { useTranslation } from 'react-i18next';
import { IGptPluginConfiguration } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';

export interface PluginsMenuProps {
    plugins: IGptPluginConfiguration[];
    pluginsChanged: (plugins: string[]) => void;
}

// renders the list of plugins that the user can select autonomously, if enabled
export const PluginsMenu: FC<PluginsMenuProps> = (props: PluginsMenuProps) => {
    const [activePlugins, setActivePlugins] = useState<string[]>([])
    const confirm = useConfirm();
    const { t } = useTranslation();

    const handlePluginChanged = (plugin?: string) => {
        if (!plugin) {
            return;
        }

        confirm({
            message: '',
            show: true,
            title: t(`conversation.plugins.${plugin}.disclaimer`),
            cancelText: t('No'),
            confirmText: t('Yes'),
            catchOnCancel: true
        }).then(() => {
            setActivePlugins([plugin]);
            props.pluginsChanged([plugin]);
        }).catch(() => {
            setActivePlugins([]);
            props.pluginsChanged([]);
        });
    }

    const multiplePluginsChanged = (_: MenuCheckedValueChangeEvent, data: MenuCheckedValueChangeData) => {
        // TODO: make handlePluginChanged working for multiple plugins
        setActivePlugins(data.checkedItems);
        props.pluginsChanged(data.checkedItems);
    }

    const singlePluginChanged = (_: ChangeEvent<HTMLInputElement>, data: SwitchOnChangeData) => {
        if (data.checked) {
            handlePluginChanged(props.plugins[0].id);
        } else {
            setActivePlugins([]);
            props.pluginsChanged([]);
        }
    }

    return (
        <>
            {
                props.plugins.length > 0
                    ? <div className='pluginsContainer'>
                        {
                            props.plugins.length === 1
                                ? <Switch name='plugin' value={props.plugins[0].id} checked={activePlugins.length > 0} label={props.plugins[0].name} onChange={singlePluginChanged} />
                                : <Menu onCheckedValueChange={multiplePluginsChanged}>
                                    <MenuTrigger disableButtonEnhancement>
                                        <Button icon={activePlugins.length > 0 ? <AppsFilled /> : <AppsAddInRegular />} size='large'>Tools</Button>
                                    </MenuTrigger>
                                    <MenuPopover>
                                        <MenuList>
                                            {
                                                props.plugins.map(p =>
                                                    <MenuItemSwitch key={p.id} icon={getPluginIcon(p.id)} name='plugin' value={p.id!}>
                                                        {p.name}
                                                    </MenuItemSwitch>
                                                )
                                            }
                                        </MenuList>
                                    </MenuPopover>
                                </Menu>
                        }
                    </div>
                    : null
            }
        </>
    );
};